import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Callback from './components/Callback';

// Pages
import Dashboard from './pages/Dashboard';
import Resources from './pages/Resources';
import Assistant from './pages/Assistant';
import Analytics from './pages/Analytics';
import Lesson from './pages/Lesson';
import Portal from './pages/Portal';

import { AuthWall } from './components/AuthWall';
import { Navbar } from './components/ui/Navbar';
import { useEffect, useState } from 'react';

function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    setSession(localStorage.getItem('accessToken'));
  }, []);

  return (
    <div className="min-h-screen dark:bg-zinc-700 bg-zinc-300 transition-all">
      <Navbar session={session} />
      <div className="flex flex-col justify-center items-center">
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="*" element={<Navigate to="/" />} />

            {/* Staff Pages */}
            <Route path="/dashboard" element={<AuthWall children={<Dashboard />}></AuthWall>} />
            <Route path="/resources" element={<AuthWall children={<Resources />}></AuthWall>} />
            <Route path="/assistant" element={<AuthWall children={<Assistant />}></AuthWall>} />
            <Route path="/analytics" element={<AuthWall children={<Analytics />}></AuthWall>} />
            <Route path="/lesson/:id" element={<AuthWall children={<Lesson />}></AuthWall>} />
            <Route path="/portal" element={<AuthWall children={<Portal />}></AuthWall>} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;
